/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { ParticipantStatuses } from './constants';

const routes = {
	preStudy: '/pre-study',
	moderatedAccessAgreement: '/moderated/access-agreement',
	moderatedScreener: '/moderated/screener',
	screener: '/screener',
};

const moderatedRouteByStatus: Record<string, string> = {
	[ParticipantStatuses.Candidate]: routes.moderatedAccessAgreement,
	[ParticipantStatuses.Qualified]: routes.moderatedAccessAgreement,
	[ParticipantStatuses.StudyEntered]: routes.moderatedAccessAgreement,
	[ParticipantStatuses.ScreenerEntered]: routes.moderatedScreener,
};

const routeByStatus: Record<string, string> = {
	[ParticipantStatuses.Candidate]: routes.preStudy,
	[ParticipantStatuses.Qualified]: routes.preStudy,
	[ParticipantStatuses.StudyEntered]: routes.preStudy,
	[ParticipantStatuses.ScreenerEntered]: routes.screener,
};
// eslint-disable-next-line import/prefer-default-export
export function getRedirectUrlFromStatus(
	status: string,
	token: string,
	isModeratedScreener: boolean = false,
	isModeratedStudy = false
): string {
	if (isModeratedStudy) {
		return `${routes.preStudy}?token=${token}`;
	}
	const baseRoute = isModeratedScreener ? moderatedRouteByStatus[status] : routeByStatus[status];

	const route = `${baseRoute}?token=${token}`;

	return route;
}
